import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import LessonComponent from './components/lesson/LessonComponent';
import LessonApi from '../modules/lessons/api/LessonApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import AceEditor from 'react-ace';
import { Form, Input, Button, Grid, Checkbox, Dropdown, Header } from 'semantic-ui-react';

import 'brace/mode/xml';
import 'brace/theme/monokai';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import Course from '../modules/lessons/domain/aggregates/course/Course';
import CourseApi from '../modules/lessons/api/CourseApi';
import ExerciseTemplate from '../modules/lessons/domain/aggregates/exerciseTemplate/ExerciseTemplate';
import ExerciseTemplateApi from '../modules/lessons/api/ExerciseTemplateApi';

interface Props {
	id?: string;
	courseId?: string;
}

interface State {
	lesson?: Lesson;
	lessons: Lesson[];
	courses: Course[];
	exercises: Exercise[];
	exerciseTemplates: ExerciseTemplate[];
}

export default class EditStoryPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], exercises: [], exerciseTemplates: [], courses: [] };
	}

	async componentWillMount () {
		const courses = await CourseApi.getInstance().getAll();
		const lessons = await LessonApi.getInstance().getAll();
		const exerciseTemplates = await ExerciseTemplateApi.getInstance().getAll();

		const lessonIdValue = this.props.match.params.id;
		const lesson = lessonIdValue === undefined ? Lesson.create() : lessons.find(lesson => lesson.getId().equals(new EntityId<Lesson>(Number(lessonIdValue)))) as Lesson;
		const exercises = lesson.hasId() ? await ExerciseApi.getInstance().getAllByLessonId(lesson.getId()) : [];

		const courseIdValue = this.props.match.params.courseId;
		if (lessonIdValue === undefined && courseIdValue !== undefined) {
			lesson.updateCourseId(new EntityId<Course>(Number(courseIdValue)));
		}

		if (!lesson.hasContent()) {
			lesson.updateContent(emptyLessonContent());
		}

		this.setState({lesson, lessons, exercises, exerciseTemplates, courses});
	}

	protected saveLesson = async (event: Event) => {
		event.preventDefault();

		let lesson = this.state.lesson as Lesson;

		lesson = await LessonApi.getInstance().save(lesson);

		Page.navigate(lesson.getSlug());
	}

	protected isLoading () {
		return this.state.lesson === undefined;
	}

	protected renderTitle () {
		return (this.state.lesson as Lesson).getTitle();
	}

	protected renderDescription () {
		return 'Learn ' + (this.state.lesson as Lesson).getTitle() + ' and other lessons at our digital education platform.';
	}

	protected renderContent () {
		const lesson = this.state.lesson as Lesson;

		return (
			<div>
				<Grid columns={2} stackable>
					<Grid.Column>
						<Form inverted onSubmit={this.saveLesson} style={{position: 'sticky', top: '72px'}}>
							<Form.Field>
								<label>Story</label>
								<AceEditor mode='xml' theme='monokai' width='100%' height='512px' showPrintMargin={false} value={lesson.getContent()} onChange={(content) => this.setState({lesson: lesson.updateContent(content)})}  />
								<Button primary fluid style={{marginTop: '2em'}}>Save lesson</Button>
							</Form.Field>
						</Form>
					</Grid.Column>
					<Grid.Column>
						<div className='lesson'>
							<Header as='h1' dividing inverted content={lesson.getTitle()} subheader={lesson.getSubtitle()} />

							<LessonComponent lesson={lesson} noButtons={true} />
						</div>
					</Grid.Column>
				</Grid>
			</div>
		);
	}
}

function emptyLessonContent () {
	return `<p>
    Welcome to the story editor.
    You can type your story to the left, and see the result at the right.
</p>

<p>
    Paragraphs are written between <strong>p</strong> tags, and <strong>returns</strong> have no effect.
    <strong>Bold</strong> words are written between <strong>strong</strong> tags.
    You can write mathematical expression using <strong>Math</strong> tags: <Math>e=mc^2</Math>.
    And use <strong>MathBox</strong> if you want to give it some space.
    <MathBox>t' = t \\cdot \\frac{1}{\\sqrt{1 - \\frac{v^2}{c^2} }}</MathBox>
    If you want to know more about how to write math, <a href="http://math-on-quora.surge.sh/">follow this link</a>.
</p>

<ul>
    <li>An unordered list is created with <strong>ul</strong> tags.</li>
    <li>And each item in the list with <strong>li</strong> tags.</li>
</ul>

<ol>
    <li>An ordered list is created with <strong>ol</strong> tags.</li>
    <li>And each item in the list with <strong>li</strong> tags.</li>
</ol>

<p>
    And you can make tables with <strong>table</strong> tags.
</p>

<table>
    <thead>
        <tr>
            <th>thead contains header rows</th>
            <th>Use th for making header cells</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><strong>tbody</strong> contains body rows</td>
            <td>Use <strong>td</strong> for making body cells</td>
        </tr>
    </tbody>
</table>

<p>
    Lastly, you can add images.
    
    <img width="512px" alt="Train station with train and coal depot" src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Train_station_with_train_and_coal_depot_by_Gustave_Le_Gray1.jpg/1024px-Train_station_with_train_and_coal_depot_by_Gustave_Le_Gray1.jpg"></img>
</p>
`;
}


// WEBPACK FOOTER //
// ./code/project/pages/EditStoryPage.tsx